module.exports = __webpack_public_path__ + "img/singapore-featured-image-150x150.de09e078.jpg";